import React from 'react';
export var AppContext = /*#__PURE__*/React.createContext({
  program: null,
  initialProps: null,
  dsjState: null,
  setDsjState: null,
  eligibility: {},
  hideEligibility: false
});